export default __webpack_public_path__ + "static/media/Jahaz-Mahal-2.bf36f0ae.jpg";